import { Component, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { IconComponent, Size, Style } from '@app/shared/components/atoms/icon/icon.component';
import { Color } from '@app/shared/models/color.model';

export enum CoverSpacing {
  center = 'center',
  spaceBetween = 'space-between',
  spaceEvenly = 'space-evenly',
}

export enum ExpansionPanelState {
  default = 'default',
  readOnly = 'readOnly',
  disabled = 'disabled',
}

@Component({
  selector: 'app-expansion-panel',
  templateUrl: './expansion-panel.component.html',
  styleUrls: ['./expansion-panel.component.scss'],
  imports: [IconComponent],
  standalone: true,
})
export class ExpansionPanelComponent {
  @Input() expansionPanelId?: string;

  @Input() state: keyof typeof ExpansionPanelState = 'default';

  @Input() iconClassName?: string;

  @Input() iconStyle?: Style | undefined;

  @Input() iconSize?: Size | undefined;

  @Input() coverText: string = '';

  @Input() coverSpacing: keyof typeof CoverSpacing = 'spaceBetween';

  @Input() hoverText: string = '';

  @Input() withoutCarretIcon: boolean = false;

  @Input() hasCloseOnCLick: boolean = true;

  @Output() panelChanges: EventEmitter<boolean> = new EventEmitter<boolean>();

  protected toOpen: boolean = false;

  constructor(private elementRef: ElementRef) {}

  showDropdown(): void {
    this.toOpen = !this.toOpen;
  }

  hide(): void {
    this.toOpen = false;
  }

  @HostListener('document:click', ['$event'])
  handleOutsideClick(event: Event): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.hide();
    }
  }

  protected readonly Style = Style;

  protected readonly Size = Size;

  protected readonly Color = Color;
}
